var localCover = new Swiper ('.swiper-local-cover', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 3000
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.cover-pagination',
    type: "fraction",
    clickable: true
  }
});

var localBedrooms = new Swiper ('.swiper-local-bedrooms', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 3000
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.rooms-pagination',
    type: "fraction",
    clickable: true
  }
});

var localShops = new Swiper ('.swiper-local-shops', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 3000
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.shop-pagination',
    type: "fraction",
    clickable: true
  }
});

var localGallery = new Swiper ('.swiper-local-gallery', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 3000
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.gallery-pagination',
    type: "fraction",
    clickable: true
  }
});

var localGallery = new Swiper ('.swiper-local-nicody', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 3000
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.nicody-pagination',
    type: "fraction",
    clickable: true
  }
});


var localMeetingSpace = new Swiper ('.swiper-local-meeting-space', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  effect: 'fade',
  autoplay: {
    delay: 3000
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.meeting-space-pagination',
    type: "fraction",
    clickable: true
  }
});
  
var roomPhotos = new Swiper ('.room-photos', {
  //loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    // type: "fraction",
    clickable: true
  }
  // autoplay: {
  //   delay: 6000
  // },
  // pagination: {
  //   el: '.swiper-pagination',
  // },
});


var gallery1 = new Swiper ('.swiper-gallery-1', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 900,
  grabCursor: true,
  // effect: 'fade',
  autoplay: {
    delay: 3000
  },
  // fadeEffect: {
  //   crossFade: true
  // },
  pagination: {
    el: '.gallery-1-pagination',
    type: "fraction",
    clickable: true
  }
});

var spaceSwiperParam = {
  loop: true,
  slidesPerView: 1.3,
  spaceBetween: 15,
  speed: 900,
  grabCursor: true,
  centeredSlides: true,
  autoplay: {
    delay: 3000
  },
  breakpoints: {
    820: {
      slidesPerView: 2.5,
      spaceBetween: 30,
      }
  }
}

var swiperMorethan = new Swiper ('.swiper-morethan', spaceSwiperParam);
var swiperKei      = new Swiper ('.swiper-kei', spaceSwiperParam);
var device_type = deviceType();

if( device_type === 'pc' ) {

  var rellax = new Rellax('.rellax', {
    center: true
  });

} else {

  var rellax = new Rellax('.rellax-sp', {
    center: true
  });

}
